module.exports = __webpack_public_path__ + "img/logo-horizontal-2.6c7bf12b.svg";